const MAX_LENGTH = 1024;

// truncate はログ出力・エラー詳細など「情報が欠落しても害が小さい」場所でしか使われない前提で、
// 型を string に絞らず unknown を受け付ける。呼び出し元が型ガードを忘れても TypeError で
// エラー配線そのものが沈黙する事故を防ぐことを最優先し、内部で安全に文字列化する。
//
// - null / undefined は空文字列に倒す（'null' / 'undefined' というリテラル文字列はログとして情報価値がないため）
// - string はそのまま
// - それ以外は String(value) で文字列化する。object.toString() が throw するケースは
//   try/catch で受けて typeof 情報を残したフォールバック文字列に倒す（Symbol.toPrimitive の
//   カスタム実装や Proxy の get トラップで例外が投げられる可能性への保険）
export function truncate(value: unknown): string {
  return toSafeString(value).slice(0, MAX_LENGTH);
}

// String() が throw する病的な値（Symbol.toPrimitive のカスタム実装、Proxy の get トラップ、
// toString を override した object など）でも例外を漏らさず文字列化する。
// truncate の内部実装であると同時に、長さ制約が不要な場面（呼び出し側で連結後に別途 truncate される
// ケースなど）で単体で使うことも想定して export する。
export function toSafeString(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  try {
    return String(value);
  } catch {
    // typeof 情報だけでも残す。ログを見た開発者が「何かの object の toString が壊れていた」と
    // 追跡できる程度の手がかりにはなる。
    return `[unserializable ${typeof value}]`;
  }
}
